{
  "navigation_tabbar": {
    "home": "Home",
    "create": "Book",
    "coworkers": "Co-workers",
    "more": "More"
  },
  "titles": {
    "book_license_plate": "Vehicle license plate",
    "more_settings": "Settings",
    "more_privacy": "Privacy",
    "more_profile": "My profile",
    "more_management": "Management",
    "more_inbox": "Inbox",
    "more_about_my_office_days": "About $t(app_name)",
    "more_calendar_subscription": "Connect bookings to calendar",
    "more_accounts": "Accounts",
    "more_workdays": "My workdays",
    "today": "Home",
    "add_booking_date": "Timeslots",
    "add_booking_license_plate": "Vehicle registration number",
    "add_booking_lunch": "Lunch choice",
    "add_booking_overview": "Check bookings",
    "add_booking_success": "Bookings made",
    "invitation_received": "Invitations received",
    "invitation_sent": "Invitations sent",
    "more_inbox_view": "inbox",
    "presence_scan": "Scan attendance",
    "presence_transport": "Transport choice",
    "more_index": "More",
    "add_booking_option": "Book",
    "coworkers": "Co-workers",
    "more_travel_history": "My travel history",
    "events": "Events",
    "event_view": "Event",
    "more_lunch_scanner": "Lunch scanner",
    "add_booking_location": "Location",
    "add_booking_view_coworker": "Selected co-workers",
    "add_booking_select_coworker": "Select co-workers",
    "coworkers_view": "Co-worker",
    "coworkers_filter_selection": "Filter",
    "coworkers_filter_results": "Filter results",
    "qrcode_scan": "QR-code scan",
    "credits": "Credits",
    "credits_buy": "Buy credits"
  },
  "tabs": {
    "more_settings_privacy": "Privacy",
    "more_settings_settings": "App",
    "more_settings_cache": "Cache",
    "more_travel_history_history": "History",
    "more_travel_history_profiles": "Profiles"
  },
  "buttons": {
    "cache_clear": "Clear cache",
    "save": "Save",
    "cancel": "Cancel",
    "ok": "Ok",
    "logout": "Logout",
    "change_to_app": "To app",
    "book": "Book",
    "view": "View",
    "buy": "Buy"
  },
  "loading": {
    "capacity": "Calculating capacity",
    "team_members": "Loading team members",
    "search_results": "Searching",
    "external_contacts": "Loading your contacts",
    "messages": "Loading your messages",
    "timeslot_groups": "Loading timeslot groups",
    "timeslot_kinds": "Loading timeslot kinds"
  },
  "saving": {
    "booking": "Placing booking(s)"
  },
  "hints": {
    "title": "$t(app_name) tip",
    "booking_invite_click_employee_to_accept": "You can change the status to accepted by clicking on the person"
  },
  "text": {
    "unread_messages": "You've got {{amount}} unread messages"
  },
  "enums": {
    "employee_status": {
      "unknown": "Onbekend",
      "in_meeting": "In bespreking",
      "having_lunch": "Having lunch",
      "present": "Present",
      "not_yet_present": "Not yet present",
      "left": "Not present anymore",
      "work_from_home": "Works from home",
      "work_from_home_2": "Works from home"
    },
    "read_more": "Read more",
    "license": {
      "license_plate": {
        "title": "License plate"
      },
      "car_fuel_type": {
        "title": "Fuel type"
      },
      "car_length": {
        "title": "Length"
      },
      "car_width": {
        "title": "Width"
      },
      "car_height": {
        "title": "Height"
      },
      "car_weight": {
        "title": "Weight"
      }
    }
  },
  "pages": {
    "authentication": {
      "qr-code": {
        "title": "Through App",
        "explanation-1": "Open the $t(app_name) app.",
        "explanation-2": "Press the QR-code icon on the top right of the homescreen.",
        "explanation-3": "Scan the qr-code to login!"
      },
      "token": {
        "title": "Through Token (SMS/E-mail)"
      },
      "testflight": {
        "title": "$t(app_name) Beta",
        "description": "Thank you for participating in the Beta test of $t(app_name)!\n\nWe hope everything works as expected but if there are any issues please let us know.\n\n\nUnable to book your workspaces or have major issues with this beta version? You can install the stable version from the Apple app-store/Google play store ",
        "ok": "Ok"
      }
    },
    "loading": {
      "slow_connection": "Loading takes longer than expected\nplease check your internet connection"
    },
    "home": {
      "favourite_presence": {
        "title": "Favourite co-workers",
        "no_bookings_favourites": "Your favourite co-workers currently have no bookings on {{date}}"
      },
      "update": {
        "available": "There's an update available for $t(app_name)! We recommend you update to the latest version which only takes a few seconds",
        "update_now": "Update now",
        "hide": "Hide"
      },
      "build": {
        "available": "There's an update available for $t(app_name) in the store! We recommend you update to the latest version which only takes a few seconds",
        "goto_app_store": "Goto store",
        "hide": "Hide"
      }
    },
    "book": {
      "license_plate": {
        "explanation": "To access the parking space you'll need to provide the license plate of the vehicle you'll be parking",
        "multi_option": "Use the text input  below to change all license plates at once.",
        "default_not_set": "Always going to the office with the same car? You can set your license plate in your profile which will be input by default which saves you some precious time!",
        "invalid": "The entered license plate cannot be found",
        "limitation_error": "This vehicle does not meet the required limitations.",
        "modal": {
          "title": "Information",
          "text": "Your vehicle does not meet the required limitations. The error messages are listed below:"
        },
        "errors": {
          "car_fuel_type": "Does not meet the required fuel type",
          "car_length": "Does not meet the maximum length",
          "car_width": "Does not meet the maximum width",
          "car_height": "Does not meet the maximum height",
          "car_wheelbase": "Does not meet the maximum wheelbase",
          "car_weight": "Does not meet the maximum weight",
          "current": "Current: {{value}}",
          "allowed": "Allowed: {{value}}"
        },
        "is_same": "The entered license plates for this time slot are the same. This is not allowed.",
        "car_dimensions_missing": "We cannot fully verify this license plate because the data is not available from the RDW. After booking, it will be manually checked."
      }
    },
    "more": {
      "sections": {
        "account": "Account",
        "preferences": "Preferences and connections",
        "session": "Account access"
      },
      "settings": {
        "cache": {
          "explanation": "By storing information that doesn't change often on your phone, caching makes $t(app_name) feel much smoother. Do you feel that information is not up-to-date after all? Then clear the cache to get the latest information."
        }
      },
      "profile": {
        "resolve_error": "The following information is missing from your profile, please supply the missing information to continue using $t(app_name)",
        "errors": {
          "no_team": "There's no team selected",
          "address": "The postal code could not be found",
          "no_address": "You have not entered a postal code yet",
          "no_license_plate": "You have not entered a license plate yet",
          "no_transport_kind": "You have not selected a transport option yet"
        },
        "no_preference": "No default preference"
      },
      "about": {
        "share": "Share our website",
        "view": "Visit our website",
        "block_1": "Thanks a lot for using $t(app_name). We hope you are one of the thousands satisfied users of $t(app_name). Want to let friends and family know how easy it can be to have some ‘office days’ too? You would help us out by spreading the word about $t(app_name).",
        "block_2": "Our history: $t(app_name) is part of the On-d-mand international company. On-d-mand is founded in 2005 and established in Diemen, The Netherlands. The company is specialized in developing (web) applications, mainly for multinationals. On-d-mand services are being used in over 15 countries.",
        "block_3": "The $t(app_name) app has a lot of similarities with our other services, such as the Hospitality manager software, that has been used by companies such as Ziggo, Aegon, Funda, Coca cola and Heineken for over 10 years. They use the Hospitality manager software to record the invitation and registration process for the events they sponsor.",
        "explanation": "."
      },
      "accounts": {
        "saved_accounts": "Saved accounts",
        "save_error_title": "Account could not be saved",
        "save_error": "Could not save your account on this device. Please try again.",
        "add_account": "Add account",
        "active_account": "Active account",
        "other_accounts": "Other accounts",
        "will_logout": "When adding a new account you will be logout automatically. Login to your new account to add it to your device.",
        "enable_multi_account": "Enable multi accounts",
        "remove_all_accounts": "Remove all other accounts"
      }
    },
    "coworker_favourites": {
      "no_favourites": "Your favourites list is empty, search for employees and click on the little heart next to their name to start adding them!"
    },
    "coworker_eros": {
      "no_eros": "It seems there are no ero employees in the office today!"
    },
    "coworker_confidants": {
      "description": "Do you want a listening ear, advice or help with undesirable behaviour? Contact a confidential adviser.\n\nWe're there for you!",
      "no_confidants": "No confidants found"
    }
  },
  "alerts": {
    "are_you_sure": {
      "title": "Are you sure?"
    },
    "are_you_sure_multi_account": {
      "title": "Are you sure?",
      "message": "There are multiple accounts connected to this device, if you choose to logout all connect accounts will be removed from this device"
    }
  },
  "constants": {
    "ero": "ERO",
    "confidant": "Confidant",
    "location": "Location",
    "workplaces_count": "Workplaces available",
    "coworkers_booked": "Co-workers",
    "information": "Information",
    "status": "Status",
    "lunches_count": "Lunches available",
    "meetingroom_count": "Seats available",
    "transport_count": "Parkingspots available",
    "lunch_option": "Lunch option",
    "license_plate": "License plate",
    "capacity_remaining": {
      "booking": "{{capacity_remaining}}"
    },
    "not_available": {
      "booking": "Not available"
    },
    "no_capacity_remaining": {
      "booking": "Not available "
    },
    "insufficient_capacity_remaining": {
      "booking": "Insufficient ({{capacity_remaining}} of {{required_amount}})"
    },
    "timeslots": {
      "booking": "Workplaces",
      "lunch": "Lunch",
      "transport": "Parking",
      "meeting_room": "Meeting room",
      "custom": "Custom"
    },
    "edit": "Edit",
    "scan_status": "Scan status",
    "parking_scan_status": "Parking scan status",
    "not_in_office": "Not in the office",
    "date": "Date",
    "time": "Time",
    "coworker": "Co-worker",
    "credit": "Credit costs"
  },
  "page": {
    "home": {
      "greeting": "Hi {{name}},",
      "in_the_office": "Did you arrive at the office?",
      "welcome_in_the_office": "Welcome to the office, have a great day!",
      "left_the_office": "Did you leave?"
    },
    "notifications": {
      "app_update_required": {
        "title": "Update required",
        "description": "You're currently not running the latest version of our app, this update is required to continue using the app. Use the button below to visit the {{store}} and download the latest version"
      },
      "maintenance": {
        "title": "Maintenance",
        "description": "We are currently busy with maintenance of your environment, it is therefore not possible to make or view bookings.\n\nThis screen will disappear automatically as soon as we're done.",
        "countdown": "Checking our progress in {{seconds}} seconds"
      },
      "ota_update_required": {
        "title": "Update required",
        "description": "You are not currently running an up-to-date version of our app, to continue you must have the latest version installed. By pressing the button below, the latest version of the app will be downloaded."
      },
      "ignore": "Ignore",
      "open_store": "Open {{store}}"
    },
    "create": {
      "overview": {
        "save": {
          "alert_title": "Failed",
          "alert_message": "An unknown error occurred while saving the bookings, please try again."
        },
        "intro_other": "Check the chosen timeslots",
        "intro": "Check the chosen timeslot",
        "no_timeslots": "No time slots have been selected",
        "booking_save": "Place booking",
        "title": "Validate bookings",
        "invitation_save": "Confirm booking",
        "invitation_save_other": "Confirm bookings",
        "booking_save_other": "Place bookings",
        "form": {
          "reason": {
            "title": "Reason for booking"
          },
          "description": {
            "title": "Description"
          },
          "name": {
            "title": "Title"
          },
          "show_invitees": {
            "title": "Show the invitees in the invitation that will be sent"
          }
        },
        "users": {
          "title": "Invitees"
        },
        "bookings": {
          "title": "Bookings"
        },
        "captcha_modal": {
          "title": "Failed to place booking",
          "text": "Unfortunately, the booking was not successful. We recommend trying again. If the issue persists, please contact our customer service for further assistance."
        }
      },
      "lunch": {
        "intro": "Use the drop-down list below to change all chosen lunch options at once.",
        "title": "Lunch options",
        "profile_default_not_set": "Got a lunch preference? You can set the default value in your profile which saves you some precious time!",
        "profile_default": "Your choice according to your profile",
        "option_only_myself": "The lunch option only applies to your booking."
      },
      "date": {
        "no_timeslot_other": "There are no time slots available",
        "no_timeslot": "There is no time slot available",
        "disabled_overlap": "You already have a booking on this timeslot",
        "warning": {
          "cart": {
            "title": "Pay attention",
            "body": "This chosen time slot overlaps with another previous time slot. Do you want to replace the newly selected time slot with the previously selected time slot?",
            "button_ok": "Continue",
            "button_cancel": "Cancel"
          }
        },
        "title": "Select timeslots",
        "title_selected": "{{number}} timeslot selected",
        "title_selected_other": "{{number}} timeslots selected",
        "disabled_not_enough_available": "Not enough places available ({{count}} needed)",
        "disabled_already_booked": "This timeslot has already been booked",
        "disabled_not_inviter": "You have already booked this time slot and only the organizer can add extra co-workers",
        "disabled_not_available": "Not available",
        "disabled_already_booked_single": "You have already booked this timeslot",
        "disabled_already_booked_single_timeslot_group": "You can only book a single timeslot per day",
        "disabled_before_from": "You can book this time slot from {{amount}} {{unit}} in advance",
        "disabled_before_from_time": "You can book this time slot from {{amount}} {{unit}} in advance from {{time}}",
        "disabled_before_from_time_today": "You can book this timeslot from {{time}}",
        "disabled_deadline_passed": "You can book this timeslot up to {{amount}} {{unit}} in advance",
        "disabled_deadline_passed_time": "You can book this timeslot up to {{amount}} {{unit}} in advance until {{time}}",
        "disabled_deadline_passed_time_today": "You could book this timeslot until {{time}}",
        "validate_timeslots": "Validate bookings",
        "select_license_plate": "License plate",
        "select_lunch": "Lunch options",
        "information_invitation_exists": "This timeslot is already in an existing invitation. Additional persons will be added to the existing invitation.",
        "disabled_block": "This timeslot is not available",
        "disabled_already_booked_single_timeslot_kind": "You can only book a single {{kind}} timeslot per day",
        "disabled_already_booked_single_timeslot_kind_current": "(Current booking: {{current}})"
      },
      "index": {
        "title": "Place booking",
        "item_empty": "Select time slot"
      },
      "success": {
        "message": "You will be automatically returned within {{seconds}} seconds.",
        "button": "Go back",
        "message_invited": "We have sent an invitation for the additional persons specified. After your guest (s) has accepted or declined the invitation, you will receive a notification in the app."
      },
      "transport": {
        "intro": "Change all chosen transport options at once with the drop-down list below. It is of course also possible to select a separate transport option per day.",
        "title": "Transportation options"
      },
      "option": {
        "options": {
          "myself": "For myself",
          "myself_and_coworkers": "For myself and co-workers",
          "coworkers": "For co-workers",
          "coworkers_and_externals": "For co-workers and externals",
          "myself_and_coworkers_and_externals": "For myself, co-workers and external",
          "myself_and_externals": "For myself and external",
          "externals": "Externals"
        },
        "kinds": {
          "meeting_room": {
            "title": "Meeting room"
          },
          "room": {
            "title": "Workplace, lunch and parking space",
            "title_no_parking_no_lunch": "Workplace",
            "title_no_parking": "Workplace and lunch",
            "title_no_lunch": "Workplace and parking space"
          }
        }
      },
      "from_coworker": {
        "description": "Just like {{name}} you have chosen to be present at the office on '{{date, lowercase}}'. Select at least one of the option(s) below.",
        "no_booking": "No booking has been made for this day by {{name}}."
      },
      "coworker": {
        "check_coworkers": "Check co-workers",
        "create_booking": "Start booking",
        "mode_favourites": "Favourites",
        "mode_co_workers": "Co-workers",
        "mode_external": "External Relations",
        "empty": "No persons found",
        "external": {
          "button_add": "Manually add guest",
          "button_add_from_phone": "Connect to phone's contact list",
          "not_stored_on_server": "Contacts are only stored on your phone",
          "not_stored_on_server_click": "click to read more",
          "not_stored_on_server_popup": "Your contact list automatically loaded from your phone and will not be stored in the application or our servers!\n\nWhen you make a booking for the contact his/her name and e-mailaddress will be used by $t(app_name) to register their booking and the information will be removed within a set timeframe of your employer (usually within 30 days after the booking)",
          "description": "Invite your guests by entering their details. They will receive an email and can confirm or decline, without needing to install the $t(app_name) app.",
          "only_email": "Note, only contact with an e-mailaddress are available below",
          "search": {
            "input_search": "Search your contact list"
          }
        },
        "alerts": {
          "changing_coworker": "Changing the co-worker will reset the selected timeslots, are you sure?"
        },
        "search": {
          "input_search": "Search within the company",
          "button_toggle_selected": "Only show selected"
        },
        "subtitle": "{{amount}} co-worker",
        "subtitle_other": "{{amount}} co-workers"
      },
      "alert_booking_occupied": {
        "title": "Timeslot has already been booked",
        "description": "Your chosen time slot on {{date}} has just been booked by your co-worker. We have automatically removed the time slot from your selected time slots."
      }
    },
    "start": {
      "title": "Today",
      "greeting": {
        "morning": "Good morning, {{name}}",
        "afternoon": "Good afternoon, {{name}}",
        "evening": "Good evening, {{name}}",
        "night": "Good night, {{name}}"
      },
      "no_booking_today": "No bookings have been made for today",
      "your_day": "This is what your day looks like",
      "button_scan_in": "Check-in",
      "button_scan_out": "Check-out",
      "button_mode_of_transport": "Mode of transport",
      "button_mode_of_transport_check_in_first": "Check-in first",
      "scan_explanation": "Use the button below to scan in for today",
      "scan_status": "Status",
      "scan_statuses": {
        "is_not_scanned_in": "Not checked in",
        "is_scanned_in": "Checked in",
        "is_scanned_out": "Checked out"
      },
      "capacity_status": {
        "no_one": "There no-one present",
        "not_busy": "It's not that busy",
        "moderately_busy": "It's not too crowded",
        "very_busy": "It's quite crowded"
      },
      "prognosis_status": {
        "no_one": "Estimated: No bookings",
        "not_busy": "Estimated: won't be that busy",
        "moderately_busy": "Estimated: will be not too crowded",
        "very_busy": "Estimated: will be quite crowded"
      },
      "profile": {}
    },
    "booking": {
      "no_booking_found_date": "No booking has been found on {{date}}",
      "no_booking_found_date_coworker": "No booking has been found on {{date}} for {{name}}",
      "calendar": {
        "title": "Bookings made",
        "add_calendar": "Add to my calendar",
        "calendar": {
          "title": "Calendar"
        },
        "invitations": {
          "title": "Invitations",
          "item": {
            "title": "Invitation on {{date}}",
            "subtitle": "Created by {{name}} on {{date}}",
            "name": "Invitation"
          },
          "empty": "No invitations found",
          "received": "Received invitation",
          "sent": "Sent invitation"
        }
      },
      "invite": {
        "title": "Invitation",
        "description": "You have been invited by {{name}}.",
        "not_found": "We have not been able to find the invitation anymore. This could be because the invitation has been withdrawn or the invitation has expired.",
        "description_select": "Below are the time slot(s) to which you have been invited, press on the time slot(s) you wish to accept and press on save below.",
        "respond": "You have already responded to this invitation. It is not possible to make adjustments here."
      },
      "status": {
        "invited": "Invited",
        "invite_accepted": "Accepted",
        "invite_rejected": "Rejected",
        "cancelled": "Cancelled",
        "active": "Active"
      },
      "status_manual_validation": "This booking is not yet final and is still being validated."
    },
    "booking_subscription": {
      "title": "Calendar subscription",
      "explanation": "You can have your bookings automatically added to your phone's calendar. Your calendar will then be automatically updated with new bookings.",
      "button": "Add subscription to my {{name}} calendar",
      "button_copy": "Copy calendar link"
    },
    "scan": {
      "title": "Scan",
      "scanned": {
        "error": "Failed to save the scan, please try again.",
        "error_title": "Failed",
        "error_no_booking": "It seems you have no active bookings today, checkin is therefore not possible",
        "error_no_booking_title": "Failed",
        "error_insufficient_access": "You do not have sufficient access to book this location",
        "error_insufficient_access_title": "Failed",
        "error_title_no_booking": "Failed",
        "error_no_rights_to_scan_presence_qr_code": "You do not have sufficient rights to scan this type of QR code and record its presence",
        "error_no_rights_to_scan_presence_qr_code_title": "insufficient rights"
      },
      "scan_success": "Scanning of the QR code was successful, you are now checked in!",
      "scan_in": "Check-in",
      "scan_out": "Check-out"
    },
    "validate_booking": {
      "title": "Check-in employee",
      "errors": {
        "code_expired": "Qr-code expired",
        "code_invalid": "Qr-code/booking is invalid",
        "scanned_in": "Employee is already scanned in"
      },
      "buttons": {
        "checkin": "Check-in",
        "cancel": "Scan other QR-code"
      }
    },
    "coworker": {
      "title": "Co-workers",
      "favourites": "Favourites",
      "search": "Search",
      "add": "Add",
      "no_following": "You're don't have any favourite co-workers",
      "no_followers": "No co-workers have you as a favourite",
      "cancel_search": "Cancel",
      "following": "Is a favourite",
      "followers": "Has you as a favourite",
      "calendar": {
        "button_book_also": "Also book these bookings for {{date, lowercase}}"
      },
      "followed": "Has you as a favourite",
      "following_not": "Not a favourite",
      "followed_not": "Doesn't have you as favourite",
      "alert": {
        "unfollow_coworker": {
          "title": "Are you sure?",
          "description": "Are you sure you want to stop following {{name}}?"
        },
        "unfollow_non_coworker": {
          "title": "Are you sure?",
          "description": "Are you sure you want to stop following {{name}}? You can only follow him/her by receiving the share link."
        },
        "unfollowed_coworker": {
          "title": "Are you sure?",
          "description": "Are you sure you want to prevent {{name}} from following you?"
        },
        "unfollowed_non_coworker": {
          "title": "Are you sure?",
          "description": "Are you sure you want to prevent {{name}} from following you? He/she can only follow you again after receiving the share link."
        },
        "ok": "Ok",
        "cancel": "Cancel"
      },
      "dotmenu": {
        "add_coworkers": "Add co-workers",
        "my_qr_code": "Share my bookings with co-workers"
      },
      "eros": "ERO's",
      "confidants": "Confidants",
      "no_ero": "There are no EROs registered for today",
      "search_list": {
        "team": "Result within the team",
        "organization": "Result within the company"
      },
      "filter": {
        "title": "Filter",
        "no_filters": "No filters set"
      },
      "filters": {
        "apply": "Apply",
        "close": "Close",
        "change": "Change filter",
        "filter_names": {
          "company_guid": "Company",
          "department_guid": "Department",
          "jobtitle_guid": "Job title",
          "name": "Name",
          "team_guid": "Team"
        },
        "filters": "Filters",
        "no_filters": "Choose from the filters to start searching",
        "no_filters_short": "No filters",
        "searching": "Searching",
        "no_results": "No results found based on set filters",
        "remove_selection": "Remove selection",
        "reset": "Reset filters",
        "title": "Filter",
        "view_results": "Show {{amount}} results",
        "too_many_results": "{{amount}}+ results, refine filters"
      },
      "title_singular": "Co-worker"
    },
    "share": {
      "title": "QR-code",
      "my_code": "My qr-code",
      "scan_code": "Scan a qr-code",
      "explanation": "By sharing your QR-code a co-worker gains access to all your bookings",
      "share_link": "Please follow my bookings on $t(app_name) by following this link {{- url}}",
      "error": "The invitation link creation failed",
      "button_try_again": "Try again",
      "button_share": "Share my invite link"
    },
    "search": {
      "title": "Add co-workers",
      "follow_added": "You're now following {{name}}",
      "no_result": "No co-workers were found",
      "department_mode": "Your team",
      "scan_mode": "Scan QR-code",
      "result_for": "Result for \"{{query}}\""
    },
    "information": {
      "title": "Information",
      "source": "Source: RIVM",
      "block": {
        "wash_hands": "Wash your hands regularly",
        "dont_shake_hands": "Do not shake hands",
        "distance": "Keep 1.5 meters away",
        "cough": "Cough in your elbow",
        "stay_home": "Do you have complaints? Report this to your manager and stay at home!",
        "title": "Only together can we get corona under control"
      },
      "buttonbar": {
        "messages": "Messages",
        "covid": "Corona guidelines"
      },
      "no_messages": "There are currently no messages"
    },
    "profile": {
      "title": "Profile",
      "save": "Save",
      "saved": "Profile saved successfully",
      "logout": "Log out",
      "profile": {
        "ad_sync_enabled": "You're personal information as managed by your employer",
        "no_roll_permission": "Sorry, we need camera roll permissions to upload a profile photo",
        "title": "Profile"
      },
      "settings": {
        "title": "Settings",
        "no_settings": "There are no settings available",
        "clear_cache": "Clear"
      },
      "ero": {
        "title": "ERO",
        "introduction": "If you are a emergency response officer (ERO), you can indicate this on this page. As an ERO co-workers can call you directly in case of an emergency when you're in the office.",
        "is_ero": "{{name}} is an emergency response officer"
      }
    },
    "message": {
      "title": "Messages",
      "empty": "There are no messages yet.",
      "action": {
        "read_all": "Mark everything as read",
        "archive_all": "Archive all messages"
      }
    },
    "message_view": {
      "title": "Message",
      "attachment": {
        "button_view_employee_booking_invitation": "View invitation",
        "button_view_employee_booking_INVITATION_SENT": "View overview"
      },
      "action": {
        "archive": "Archive message"
      }
    },
    "authentication": {
      "domain": {
        "alerts": {
          "account_locked": {
            "message": "Your account is blocked because of multiple errors during the token entry. Please try again in 15 minutes.",
            "title": "Account blocked"
          },
          "something_went_wrong": {
            "message": "We're sorry but it seems something went wrong, please try again",
            "title": "Something went wrong"
          },
          "user_not_found": {
            "message": "Your e-mail could not be found, please contact your administrator",
            "title": "E-mail not found"
          },
          "no_management_access": {
            "title": "No management access",
            "message": "Your account has no access to the management environment, please contact the $t(app_name) team for more information."
          },
          "invalid_token": {
            "message": "Your token seems to be invalid, please try again",
            "title": "Token invalid"
          },
          "token_resend": {
            "message": "A new token has been sent through e-mail, always enter the last token received.",
            "title": "Token resend opnieuw verzonden"
          }
        },
        "button": "Send log-in token",
        "button_loading": "Sending",
        "domain": "Domain",
        "domain_hint": "Enter your organisation's domain",
        "domain_placeholder": "company",
        "domain_checking": "Checking domain…",
        "email": "Your e-mail",
        "token": "Your token",
        "errors": {
          "domain_not_found": "Domain could not be found"
        },
        "subtitle": "Sign in to your account",
        "token_sent_to": {
          "dummy": "No token was sent to this demo account, the usable token is available in the instructions",
          "email": "Your token has been sent by e-mail to {{recipient}}, please check your spam folder if you didn't receive the e-mail.",
          "sms": "Your token has been sent by text message to {{recipient}}, didn't receive the text message? You can also receive a token by e-mail.",
          "unknown": "Your token has been sent by [unknown] to {{recipient}}"
        },
        "token_hint": "6 digit token",
        "token_button_resend": "Send token again",
        "welcome": "Welcome {{name}}",
        "authentication_mode": {
          "qr": "QR-code",
          "token": "Token"
        },
        "authentication_mode_title": "Continue with",
        "title": "Welcome",
        "revalidate_token_sent": "A token has been sent for session verification."
      }
    },
    "transport": {
      "title": "Transport",
      "save": "Save",
      "intro": "How did you get to work today?",
      "text_selected": "You indicated that you came today with {{kind, lowercase}}.",
      "button_change": "Change transportation method",
      "button_cancel": "Cancel",
      "selected_not": "No transport indicated yet for {{building}}",
      "selected": "You came to {{building}} today with: {{kind, lowercase}}",
      "button_home": "Back to homepage",
      "countdown": "In {{seconds}} seconds you will be returned to the home page."
    },
    "ero": {
      "title": "ERO",
      "button_call": "Call {{name}}",
      "call_description": "Accident?",
      "building_text": "{{present}} in {{building}}",
      "emergency_description": "Life-threatening accident?",
      "button_emergency": "Call emergency service {{number}}"
    },
    "confidant": {
      "title": "Confidant",
      "description": "Call {{name}} if aliquam varius viverra eros, euismod malesuada enim tempus nec. In eros justo, rutrum vel rutrum sed, consectetur nec lacus",
      "button_call": "Call {{name}}",
      "building_text": "{{present}} in {{building}}",
      "call_description": "Need help?"
    },
    "team": {
      "title": "What's your team?",
      "description": "To continue we need to know your team, with this information we know who your direct co-workers are."
    },
    "invitation": {
      "overview": {
        "title": "Sent invitation",
        "description": "This booking concerns {{amount}} persons. You can see who still has to respond to the invitation, has accepted or declined.",
        "save": "Save",
        "cancel": "Cancel",
        "actions": {
          "revoke": "Revoke invitation",
          "accept_manually": "Manually set co-workers to accepted",
          "reject_manually": "Manually set co-workers to declined",
          "hide": "Archive invitation"
        },
        "alert": {
          "remove": {
            "title": "Delete invitation",
            "confirm": "Yes I'm sure",
            "description": "Are you sure you want to revoke the invitation? The bookings will be deleted for all invitees."
          },
          "hide": {
            "description": "Are you sure you want to archive the invitation? After this it is not possible to view the invitation from this page.",
            "title": "Archive invitation",
            "confirm": "Yes I'm sure"
          }
        }
      },
      "view": {
        "alerts": {
          "cancel": {
            "title": "Are you sure?",
            "message_some": "You have not accepted all invitations, {{amount}} invitation(s) wil be declined.",
            "message_all": "All the invitation(s) wil be declined."
          }
        }
      },
      "log": {
        "status_changed": "Status changed to {{status}}",
        "title": "Activities"
      }
    },
    "workdays": {
      "title": "Workdays",
      "introduction": "Set your working days and hours which enables co-workers to see when you're working from home if you didn't book a workplace that day.\n\nDo you have a day off or a holiday? Turn on out-of-office to make sure your co-workers don't see you're working from home.",
      "vacation_mode": "Out-of-office"
    },
    "events": {
      "no_results": "There are currently no events available.",
      "button_registration": "To register",
      "alert": {
        "title": "You are leaving the app",
        "description": "The app will open the event registration page in the browser. Are you sure you want to continue?",
        "confirm": "Open in browser"
      }
    },
    "event": {
      "empty": "Event not found"
    },
    "qr_code": {
      "title": "Scan for attendance",
      "not_available_yet": "The QR code is not available.",
      "instructions": "View instructions"
    },
    "commute": {
      "commute": {
        "title": "Commuting"
      }
    },
    "credits": {
      "item": {
        "name": "{{timeslotKind}} credit",
        "unused": "Unused credits: {{amount}}",
        "status": {
          "unused": "Credit not used",
          "used": "Credit used at {{datetime}}"
        },
        "not_enough": "You don’t have enough credits to complete the booking. Please purchase more credits to continue."
      },
      "buy": "Buy credits",
      "transactions": "View my transactions",
      "transaction": {
        "amount": "Amount",
        "status_item": {
          "created": "Created",
          "completed": "Completed",
          "pending": "Pending",
          "canceled": "Canceled"
        },
        "status": "Status",
        "credits_amount": "Credit amount",
        "price": "Price",
        "price_total": "Total price"
      }
    },
    "credits_buy": {
      "modal": {
        "description": "You're about to purchase '{{amount}}' credits for {{price}}. Click the '$t(page.credits_buy.modal.confirm)' button to proceed.",
        "confirm": "Start payment",
        "cancel": "Cancel",
        "title": "Payment",
        "change_amount": "How many times would you like to purchase {{amount}} credits?"
      },
      "payment": {
        "created": "You are being redirected to an external payment page to complete your purchase.\nOnce the payment is complete, you’ll automatically return to the app.\n\nDid you close this page by accident? No worries! You can always try again using the button below.",
        "open_payment": "Open the external payment pagep",
        "failed": "Something went wrong while processing your payment.\nNo worries. You can easily try again by clicking the button below.",
        "retry_payment": "Try ag",
        "completed": "Your payment was processed successfully.\nYou can now continue by clicking the button below.",
        "button_completed": "Go to home",
        "pending": "We’ve received your payment, but it’s still being processed.\nOnce the payment is confirmed, you can continue.\n\nYou can click the button below to return to the home page.",
        "button_goback": "Go back"
      }
    }
  },
  "error": {
    "retry_button": "Try again",
    "retry_text": "Failed to retrieve the data",
    "error_login": {
      "text": "We were unable to check your session. Press the button below to try again.",
      "button_logout": "Log out now"
    },
    "global": {
      "title": "Oops, something went wrong",
      "text": "The app ran into a problem and could not continue. We apologise for any inconvenience this has caused! Press the button below to restart the app . Please contact us if this issue persists.",
      "button": "Reload"
    }
  },
  "modal": {
    "logout": {
      "title": "Are you sure you want to log out?",
      "button": "Log out now"
    }
  },
  "form": {
    "select": {
      "placeholder": "Make a choice"
    },
    "fields": {
      "license_plate": {
        "title": "Your vehicles license plate",
        "description": "When a license plate is required for booking a parking space this value is entered by default whilst booking"
      },
      "access_card_id": {
        "title": "Access card number",
        "description": "Your access card number is used to checkin you in when using a speedgate"
      },
      "team": {
        "title": "Team"
      },
      "department": {
        "title": "Department"
      },
      "jobtitle": {
        "title": "Jobtitle"
      },
      "language": {
        "title": "Language",
        "description": "Changing the language will reset the app"
      },
      "phonenumber": {
        "title": "Mobile phonenumber"
      },
      "landline_phonenumber": {
        "title": "Landline phonenumber"
      },
      "lunch_option": {
        "description": "With the drop-down list above it is possible to select a standard lunch option for future bookings",
        "title": "Standard lunch option",
        "not_available": "There are no lunch options available"
      },
      "name": {
        "title": "Name"
      },
      "transport_kind": {
        "title": "Standard transport choice",
        "description": "With the above drop-down list it is possible to select a default transport choice for future bookings"
      },
      "response_employee": {
        "title": "Emergency response officer"
      },
      "email": {
        "title": "E-mail address"
      },
      "full_name": {
        "title": "First + last name"
      },
      "show_favourite": {
        "title": "Who can add you as a favourite",
        "description": "When a co-worker adds you as a favourite they can see your bookings on the home screen, during booking and through your profile",
        "values": {
          "no": "Nobody",
          "team": "My team",
          "company": "Everybody"
        }
      },
      "show_phonenumber": {
        "title": "Who can see your mobile phonenumber",
        "values": {
          "no": "Nobody",
          "team": "My team",
          "company": "Everybody"
        }
      },
      "show_calendar": {
        "title": "Who can see your bookings",
        "description": "Co-workers can see your bookings through your profile even if they don't have you as a favourite depending on the option you select here",
        "values": {
          "no": "Nobody (except for favourites)",
          "team": "My team (including favourites)",
          "company": "Everybody"
        }
      },
      "visible_for_employees": {
        "title": "Am I visible for other co-workers",
        "description": "Allow co-workers to find me in the app"
      },
      "scan_type": {
        "qrcode": "QR-code",
        "button": "Button"
      },
      "address": {
        "title": "Postal code",
        "description": "Enter only the first 4 digits of your postal code."
      }
    },
    "warnings": {
      "empty": "Please enter an {{field, lowercase}}",
      "invalid": "Please enter a valid {{field, lowercase}}"
    },
    "timeslot_time_select": {
      "information": "The '$t(form.timeslot_time_select.until)' field is not required and will randomize a random time every day.",
      "from": "Time",
      "until": "Until"
    }
  },
  "notification": {
    "booking_saved": "Your booking has been made",
    "scan_success": {
      "scan_in": "Checked in successfully",
      "scan_out": "Checked out successfully",
      "automatic": "Checked in automatically"
    },
    "booking_saved_other": "Your bookings have been made"
  },
  "app_name": "My office days",
  "app_domain": "@myofficedays",
  "basic": {
    "scan_in": "Check-in",
    "scan_out": "Check-out",
    "next_step": "Next",
    "loading": "Loading..",
    "ok": "Oké",
    "place_available": "Place available",
    "place_available_other": "Places available",
    "present_yes": "Present",
    "present_no": "Not present",
    "present_no_note": "It is possible that {{name}} is present, but has not checked in",
    "brightness_info": "Set the brightness of your screen to maximum before scanning the QR code",
    "transport": {
      "kind": {
        "car": "Car",
        "public_transport": "Public transport",
        "other": "Other",
        "car_sentence": "The car",
        "public_transport_sentence": "The public transport",
        "other_sentence": "Other transport",
        "bike": "Bike",
        "bike_sentence": "The bicycle",
        "car_electric": "Electric car",
        "scooter": "Scooter",
        "scooter_sentence": "The scooter",
        "car_electric_sentence": "The electric car",
        "motorcycle": "Motorcycle",
        "motorcycle_electric": "Electric motorcycle",
        "motorcycle_electric_sentence": "The electric motorcycle",
        "motorcycle_sentence": "The motorcycle"
      }
    },
    "yes": "Yes",
    "no": "No",
    "available_for": {
      "everyone": "Everyone",
      "restricted": "Restricted (Teams)",
      "restricted_employees": "Restricted (Employees)"
    },
    "cancel": "Cancel",
    "accept": "Accept",
    "and": "and",
    "reject": "Reject",
    "load_more": "Load more",
    "yourself": "Yourself",
    "organizer": "Organizer",
    "you": "You",
    "save": "Save",
    "all": "all",
    "searching": "Searching..",
    "day": "Day",
    "day_other": "Days",
    "archive": "View archive",
    "activity": "Activity",
    "more": "More",
    "continue": "Continue",
    "choose_image": "Choose an image"
  },
  "permission": {
    "camera": {
      "request_permission": "Requesting for camera permission",
      "request_button": "Allow camera access",
      "no_permission": "We are not authorized to use the camera. The camera is required to scan the QR code to register your presence.",
      "settings_button": "Open settings"
    }
  },
  "date": {
    "week": "Week",
    "days": {}
  },
  "updates": {
    "start": {
      "title": "The new update has arrived",
      "subtitle": "The app is completely up-to-date again and is full of new functions!"
    },
    "1_2_0": {
      "profile_lunch": {
        "title": "Standard lunch option",
        "subtitle": "In your profile it is now possible to select your default lunch option. When booking a lunch, it is therefore no longer necessary to select it again and again."
      },
      "book_multiple": {
        "title": "Book more",
        "subtitle": "You can now place multiple bookings for multiple days at the same time"
      }
    },
    "basic": {
      "next": "Next",
      "skip": "Skip"
    },
    "1_3_0": {
      "look_and_feel": {
        "title": "Renewed style",
        "subtitle": "We've updated the style of the app! This update provides a calmer and better experience."
      },
      "book_transport": {
        "title": "Transport choice",
        "subtitle": "In the app it is now possible to indicate how you came to the office."
      },
      "security": {
        "title": "Enhanced security",
        "subtitle": "We have improved the security of the app, sorry that unfortunately this caused you to log in again."
      },
      "coworkers": {
        "title": "Imporoved co-worker options",
        "subtitle": "Adding co-workers and inviting co-workers has been improved!"
      }
    },
    "2_2_17": {
      "workdays": {
        "title": "Your workdays",
        "subtitle": "Let your co-workers know if you are working today! Go to 'More' > 'My workdays' to set your working days."
      }
    }
  },
  "update": {
    "title": "An update is available",
    "message": "Press the button below to update the app. Updating often only takes a few seconds.",
    "button_ok": "Update",
    "failed": {
      "title": "Update failed",
      "message": "Unfortunately it was not possible to update the app."
    },
    "up_to_date": {
      "title": "App is up to date",
      "message": "You have already installed the latest version of the app"
    },
    "check": "Check for updates"
  },
  "filters": {
    "company_guid": "Company",
    "department_guid": "Department",
    "team_guid": "Team",
    "jobtitle_guid": "Jobtitle"
  },
  "company": "Company",
  "department": "Department",
  "team": "Team",
  "jobtitle": "Job title",
  "email": "Emailaddress",
  "phonenumber": "Phonenumber",
  "test_warnings": {
    "warning": "!WARNING!",
    "domain_with_t": "You're currently using the test-application of $t(app_name).\n\nIf there's a test-environment available for your company it will be available here. Your production environment can't be used here.\n\nYou can create bookings but no workplaces will be booked in your office!",
    "test_flight": "Test flight!"
  },
  "calendar": {
    "week": "Week {{week}} - {{year}}",
    "show_week_calendar": "Show week calendar",
    "show_month_calendar": "Show month calendar"
  },
  "calendar_capacity": {
    "workplaces_available": "Available workplaces"
  },
  "unit": {
    "minute": "Minute",
    "minute_other": "Minutes",
    "day": "Day",
    "day_other": "Days",
    "week": "Week",
    "week_other": "Weeks",
    "month": "Month",
    "month_other": "Months",
    "year": "Year",
    "year_other": "Years",
    "hour": "Hour",
    "hour_other": "Hours"
  },
  "lunch_scanner": {
    "index": {
      "instructions": "Open the QR-code of your booking.",
      "scan_hint": "Hold the QR code in front of the camera. The booking details will appear here for confirmation.",
      "back": "Back",
      "switch_camera": "Switch camera",
      "settings": "Settings",
      "camera_hint": "Hold your booking QR code in front of the camera.",
      "buttons": {
        "checkin": "Checkin",
        "cancel": "Cancel"
      },
      "camera": "Camera",
      "status": {
        "VALID": {
          "intro": "You're checked.",
          "afternoon": "Have a great afternoon, {{name}}!",
          "morning": "Have a great day, {{name}}!",
          "evening": "Have a great evening, {{name}}!",
          "night": "Have a great night, {{name}}!"
        },
        "WRONG_DAY": "The QR-code is not valid for today",
        "ALREADY_CHECKED_IN": "You're already checked in",
        "INVALID": "The QR-code is invalid"
      }
    },
    "sleeping": {
      "text": "Tablet is in energy saving mode",
      "button": "Wake up"
    }
  },
  "parking_status": {
    "label": "Parking garage",
    "full": "Full",
    "free": "Free"
  },
  "notifications": {
    "request_text": "We will soon ask for your permission to send notifications. You will only receive relevant notifications about your bookings."
  },
  "ui": {
    "loading": "Loading",
    "powered_by": "Office planning powered by",
    "privacy_statement": "Privacy statement",
    "sleep": "Sleep",
    "country_netherlands": "The Netherlands",
    "onboarding_web_unavailable": "Onboarding is not available on the web.",
    "filter": "Filter",
    "unknown": "Unknown"
  },
  "debug_ui": {
    "title": "Diagnostics",
    "pages": "Pages",
    "interface_tests": "Interface tests",
    "cache": "Cache",
    "cache_updated_at": "Cache timestamps",
    "redux": "Redux",
    "push_notifications": "Push notifications",
    "update_errors": "Update errors",
    "account_errors": "Account errors",
    "transport_select": "Transport selection",
    "icons": "Icons",
    "video": "Video",
    "write_console": "Write to console",
    "clear": "Clear",
    "refresh_cache_timestamp": "Refresh cache timestamps",
    "write_data": "Write data state to console",
    "write_cart": "Write cart state to console",
    "write_design": "Write design state to console",
    "get_token": "Get token",
    "check_update_errors": "Check for update errors",
    "check_account_errors": "Check for account errors",
    "cache_size": "Calculate cache size ({{size}})",
    "no_update": "No update available",
    "error": "Error: {{message}}",
    "debug": "Debug: {{message}}",
    "account": "Account: {{domain}} - {{name}}",
    "icons_title": "Icon diagnostics"
  }
}
